export const iconFontAwesomeShapesBookmark = (
	<i className="fa-solid fa-bookmark"></i>
);
